import { Box, Heading, Text, useMediaQuery, VStack } from '@chakra-ui/react';
import { RiCopyrightFill } from 'react-icons/ri';

const DesktopFooter = ({stateProps}) => {
  const isDesktop = useMediaQuery('(min-width: 768px)',{ssr:false});
  if (isDesktop[0] === true) {
    return (
      <Box>
        <Heading variant="footer" display='flex' justifyContent='center'>
          <Text marginRight='.5rem'><RiCopyrightFill /></Text>
          <Text>Copyright {stateProps.currentYear} | Resume Scripter, LLC.</Text>
        </Heading>
        <Heading variant="footer" display='flex' justifyContent='center'>Portland, Oregon</Heading>
      </Box>
    );
  } else {
    return null;
  }
};
export default DesktopFooter;
